import { useApiV10BenefitsFeaturesGenerateRetrieve } from '@ben/api/gen/codegen';

interface UseFeaturesGenerateProps {
  benefitId?: string;
}

export const useFeaturesGenerate = ({ benefitId }: UseFeaturesGenerateProps) =>
  useApiV10BenefitsFeaturesGenerateRetrieve(Number(benefitId), {
    query: {
      enabled: false,
    },
  });
